import 'select2';
export default class Select2Manager {
    initialize() {
        $("[data-select2-custom]").each((key, element) => {
            this.initializeSelect2(element);
        });
    }

    initializeSelect2(select) {
        $(select).select2({
            "language": {
                "noResults": function () {
                    return $(select).data('select2-noresult');
                }
            },
            placeholder: $(select).data('select2-placeholder'),
            allowClear: true
        });
    }
}